var ToolbarType = /* @__PURE__ */ ((ToolbarType2) => {
  ToolbarType2["QUICK_ACTIONS"] = "QUICK_ACTIONS";
  ToolbarType2["SIDE"] = "SIDE";
  ToolbarType2["MOBILE"] = "MOBILE";
  ToolbarType2["FOOTER"] = "FOOTER";
  ToolbarType2["STATIC"] = "STATIC";
  ToolbarType2["INLINE"] = "INLINE";
  ToolbarType2["PLUGIN"] = "PLUGIN";
  ToolbarType2["FORMATTING"] = "FORMATTING";
  ToolbarType2["INSERT_PLUGIN"] = "INSERT_PLUGIN";
  ToolbarType2["TEXT"] = "ALL-TEXT-TOOLBARS";
  ToolbarType2["SHORTCUT"] = "SHORTCUT";
  ToolbarType2["LINK"] = "LINK";
  ToolbarType2["EXTERNAL"] = "EXTERNAL";
  ToolbarType2["PLUGIN_MENU"] = "PLUGIN_MENU";
  ToolbarType2["EMPTY"] = "EMPTY";
  return ToolbarType2;
})(ToolbarType || {});
var DisplayMode = /* @__PURE__ */ ((DisplayMode2) => {
  DisplayMode2["NORMAL"] = "NORMAL";
  return DisplayMode2;
})(DisplayMode || {});
export {
  DisplayMode,
  ToolbarType
};
//# sourceMappingURL=toolbarEnums.js.map
